/* src/app/pages/paciente/como-funciona/como-funciona.component.scss */
/*# sourceMappingURL=como-funciona.component.css.map */
